var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    staticClass: "scroll-top",
    attrs: {
      "fab": "",
      "tile": "",
      "outlined": "",
      "color": "white",
      "transition": "slide-x-transition"
    },
    on: {
      "click": function click($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-up icon-arrow-up-white"
  }), _c('span', {
    staticClass: "font-size-12 font-size-md-16 mt-4"
  }, [_vm._v("TOP")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }